export default __webpack_public_path__ + "assets/images/be88b67308fe6de6e8998f0d108b7653.png";